module.exports = __webpack_public_path__ + "static/media/draw-feeling-blue.d14cd80e.svg";